//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The update password request model
* 
* @param locale The locale from user settings or system default
* @param password The user password
* @param resetToken The reset token
*/
@Serializable

data class UpdatePasswordRequest (


      /* The locale from user settings or system default */
    @SerialName(value = "locale") @Required val locale: kotlin.String,


      /* The user password */
    @SerialName(value = "password") @Required val password: kotlin.String,


      /* The reset token */
    @SerialName(value = "resetToken") @Required val resetToken: kotlin.String


) {




  }

